// extracted by mini-css-extract-plugin
module.exports = {"nameWeight":"styles-module__nameWeight___G2TyI","name":"styles-module__name___23kRR","avatarImg":"styles-module__avatarImg___GIQm_","content":"styles-module__content___30nXb"};